/* eslint-disable react-hooks/exhaustive-deps */
import { Radio, Table, Space, Divider } from 'antd';
import { renderData } from './render-data';
import { useAppDispatch, useExtendedRequests } from '@core/.';
import AddRequestButton from '../AddRequestButton';
import {
  askForReview,
  fetchReviewRequests,
  selectRequest,
} from '@core/features/review-request/thunks';
import { deleteRequest } from '@core/features/review-request/thunks/deleteRequest.thunk';
import { useMemo, useState } from 'react';
import { ReviewRequest } from '@core/models';
import { MIDDLE_STYLE } from '@constants/responsive';

const columns = [
  {
    title: 'CONTACT',
    dataIndex: 'name',
    key: 'name',
    width: '32%',
  },
  {
    title: 'STATUS',
    key: 'status',
    dataIndex: 'status',
  },
  {
    title: 'REQUESTED DATE',
    key: 'date',
    dataIndex: 'date',
  },
  {
    title: 'ACTIONS',
    key: 'action',
    dataIndex: 'action',
  },
];

enum ReviewStatus {
  Reviewed = 'REVIEWED',
  Pending = 'PENDING',
  Drafted = 'DRAFTED',
}

export type RequestOperationHandler = (
  id: number,
  action: 'delete' | 'view' | 'submit',
  extraParams?: Record<string, any>
) => void;

function RequestEmailSMSTable() {
  const dispatch = useAppDispatch();
  const tabs = ['ALL', ReviewStatus.Pending, ReviewStatus.Reviewed, ReviewStatus.Drafted];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const { isLoading, isMutating, requests, pendingRequests, reviewedRequests, draftedRequests } =
    useExtendedRequests();

  const onChange = (e: any) => {
    setSelectedTab(e.target.value);
  };

  const handler: RequestOperationHandler = async (id, action, extraParams) => {
    if (action === 'view') dispatch(selectRequest(id));
    else if (action === 'delete') dispatch(deleteRequest(id));
    else if (action === 'submit') {
      await dispatch(askForReview(extraParams?.request));
      await dispatch(fetchReviewRequests());
    }
  };

  const renderedRequests = useMemo<ReviewRequest[]>(() => {
    return (
      {
        ALL: requests,
        PENDING: pendingRequests,
        REVIEWED: reviewedRequests,
        DRAFTED: draftedRequests,
      }[selectedTab] || []
    );
  }, [selectedTab, isLoading]);

  return (
    <div className="screen-card">
      <div style={{ ...MIDDLE_STYLE, justifyContent: 'space-between' }}>
        <h3>Review Requests</h3>
        <div>
          <Space direction="horizontal">
            <Radio.Group onChange={onChange} defaultValue={selectedTab}>
              {tabs.map(tab => (
                <Radio.Button value={tab}>{tab}</Radio.Button>
              ))}
            </Radio.Group>
            <AddRequestButton />
          </Space>
        </div>
      </div>
      <Divider />
      <div className="table-responsive">
        <Table
          loading={isLoading || isMutating}
          columns={columns}
          dataSource={renderData(handler, renderedRequests)}
          pagination={false}
          className="ant-border-space"
        />
      </div>
    </div>
  );
}

export default RequestEmailSMSTable;
